<template>
  <div class="hmi-extra-parameters">
    <v-btn
      small
      outlined
      color="mainBlue"
      :disabled="loading"
      @click="openDialog"
    >
      {{ $t("other_parameters") }}
    </v-btn>

    <v-dialog v-model="dialog" max-width="1000">
      <v-card flat>
        <v-card-title class="text-h6 d-flex align-center justify-space-between">
          {{ $t("other_parameters") }}
          <v-icon
            color="grey lighten-1"
            size="24"
            class="ml-2"
            @click="dialog = false"
          >
            mdi-chevron-left
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-form ref="extraForm">
            <v-row class="sections">
              <v-col cols="12" class="px-2">
                <v-card flat class="flex-col-start-start px-6">
                  <v-row
                    class="w-100"
                    no-gutters
                    style="flex-direction: row-reverse"
                  >
                    <v-col
                      v-for="[key, param] in extraParams"
                      :key="key"
                      :cols="12"
                      :md="6"
                      :lg="recommendation ? undefined : 3"
                      :xl="recommendation ? undefined : 3"
                      class="direction-ltr px-2 py-2"
                      :style="
                        recommendation ? 'flex: 0 0 20%; max-width: 20%;' : ''
                      "
                    >
                      <div class="text-subtitle-1 en-font direction-ltr mb-1">
                        {{ key }}
                      </div>

                      <v-text-field
                        background-color="background"
                        type="number"
                        :value="disableField(param) ? 'CALC' : param.value"
                        :disabled="disableField(param)"
                        :readonly="readonly"
                        :error="param.error"
                        :suffix="`(${param.unit || ''})`"
                        class="hmi-extra-input"
                        :class="{ 'error-input': param.error }"
                        @input="(val) => onChange(key, param, val)"
                        solo
                        flat
                        dense
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  UPDATE_HMI_PARAM_VALUE,
  UPDATE_HMI_PARAM_ERROR,
} from "@/core/services/store/modules/hmi/hmi.module";

export default {
  name: "HMIExtraParameters",

  props: {
    recommendation: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    ...mapGetters(["HMIParams"]),
    extraParams() {
      const result = [];
      for (const key in this.HMIParams) {
        const param = this.HMIParams[key];
        const isRegular = param.id >= 67 && param.id <= 90;
        const isRecommendationOnly = this.recommendation && key === "FR_X119_1";
        if (isRegular || isRecommendationOnly) result.push([key, param]);
      }
      return result.sort(([, a], [, b]) => a.id - b.id);
    },
  },

  methods: {
    disableField(param) {
      return this.recommendation ? !param.enable : false;
    },
    onChange(key, param, value) {
      if (this.readonly || this.disableField(param)) return;
      const numVal = Number(value);
      this.$store.commit(UPDATE_HMI_PARAM_VALUE, { key, value: numVal });
      const error = numVal > param.max || numVal < param.min;
      this.$store.commit(UPDATE_HMI_PARAM_ERROR, { key, error });
    },
    openDialog() {
      if (this.loading) return;
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.hmi-extra-parameters {
  position: absolute;
  top: 20px;
  right: 20px;
}
.error-input {
  border-color: var(--v-error-base) !important;
}
.error-input .v-input__slot {
  background-color: rgba(217, 36, 43, 0.2) !important;
}
.hmi-extra-input {
  & .v-text-field__suffix {
    font-size: 12px !important;
  }
}
</style>
